import { ENV } from "../utils";
import { apiFetch } from "./httpClient";

export class Menu {
  async getMenu(active = undefined) {
    return apiFetch(`${ENV.API_ROUTES.MENU}?active=${active}`, {
      method: "GET",
    });
  }

  async createMenu(data) {
    return apiFetch(ENV.API_ROUTES.MENU, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  }

  async updateMenu(idMenu, data) {
    return apiFetch(`${ENV.API_ROUTES.MENU}/${idMenu}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
  }

  async deleteMenu(idMenu) {
    return apiFetch(`${ENV.API_ROUTES.MENU}/${idMenu}`, {
      method: "DELETE",
    });
  }
}
